const normalizePrice = (value) => {
  if (typeof value === 'number' && Number.isFinite(value) && value >= 0) {
    return value;
  }

  if (typeof value === 'string' && value.trim()) {
    const sanitized = value.replace(/[^\d,.-]/g, '');
    const normalized = sanitized.includes(',')
      ? sanitized.replace(/\./g, '').replace(/,/g, '.')
      : sanitized;
    const parsed = Number(normalized);

    if (Number.isFinite(parsed) && parsed >= 0) {
      return parsed;
    }
  }

  return '0.00';
};

const normalizeVariation = (variation) => {
  const data = variation && typeof variation === 'object' ? variation : {};

  return {
    ...data,
    price: normalizePrice(data.price),
    promotionalPrice: normalizePrice(data.promotionalPrice),
    paused: data.paused === true,
  };
};

export const normalizeProduct = (product) => {
  const data = product && typeof product === 'object' ? product : {};
  const variations = Array.isArray(data.variations)
    ? data.variations.map(normalizeVariation)
    : [];
  let { priceType } = data;
  if (!['single', 'multiple'].includes(priceType)) {
    priceType = variations.length > 0 ? 'multiple' : 'single';
  }

  return {
    ...data,
    price: normalizePrice(data.price),
    promotionalPrice: normalizePrice(data.promotionalPrice),
    variations,
    priceType,
  };
};
